<ion-list class="block-content-round">
  <form
    [formGroup]="stopForm"
    appFormBlurNotifier
    (formBlurred)="emitModifiedData()"
    #blurNotifier="appFormBlurNotifier"
  >
    <ion-item-group>
      <ion-item-divider
        sticky
        [ngClass]="{
          '--to-load': currentStopType() === EStopType.LOAD,
          '--to-unload': currentStopType() === EStopType.UNLOAD,
          '--to-unload_load': currentStopType() === EStopType.UNLOAD_LOAD,
        }"
      >
        <div>
          <strong class="step-number">{{ currentStop().position + 1 }}</strong>

          @if (isIntermediateStop()) {
            <div class="intermediate-stop">
              <ion-select
                label="Tipo de parada"
                interface="popover"
                label-placement="floating"
                fill="outline"
                mode="md"
                name="stopType"
                formControlName="stopType"
                (ionChange)="onStopTypeChange($event)"
              >
                @for (stopType of stopTypes; track $index) {
                  <ion-select-option [value]="stopType">
                    {{ 'EStopType.' + stopType | translate | uppercase }}
                  </ion-select-option>
                }
              </ion-select>
            </div>
          } @else {
            <span class="subtitle">
              {{ 'EStopType.' + currentStopType() | translate }}
            </span>
          }

          <span class="actions">
            @if (stopsLength() > 2) {
              <ion-button
                (click)="emitRemoveStop()"
                fill="outline"
              >
                <ion-icon
                  color="danger"
                  slot="icon-only"
                  aria-label="Subir"
                  src="../assets/material-symbols/delete_24dp.svg"
                ></ion-icon>
              </ion-button>
            }

            @if (!isFirstStop()) {
              <ion-button
                (click)="emitMoveUp()"
                fill="outline"
              >
                <ion-icon
                  slot="icon-only"
                  aria-label="Subir"
                  src="../assets/material-symbols/arrow_warm_up_24dp.svg"
                ></ion-icon>
              </ion-button>
            }

            @if (!isLastStop()) {
              <ion-button
                (click)="emitMoveDown()"
                fill="outline"
              >
                <ion-icon
                  slot="icon-only"
                  aria-label="Bajar"
                  src="../assets/material-symbols/arrow_cool_down_24dp.svg"
                ></ion-icon>
              </ion-button>
            }
          </span>
        </div>
      </ion-item-divider>

      <div>
        <ion-grid>
          <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

          <ion-row>
            <ion-col>
              <h3 class="ion-margin-top-0">Horario</h3>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col
              sizeXl="6"
              size-lg="6"
              sizeMd="12"
              size="12"
            >
              <div class="">
                <ion-input
                  type="datetime-local"
                  label="Desde"
                  name="since"
                  formControlName="since"
                  placeholder=""
                  labelPlacement="floating"
                  fill="outline"
                  mode="md"
                  [min]="minSinceDate()"
                  helperText="Día y hora prevista mínima para el inicio de la operación"
                  [errorText]="errorText['since']"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col
              sizeXl="6"
              size-lg="6"
              sizeMd="12"
              size="12"
            >
              <div>
                <ion-input
                  type="datetime-local"
                  label="Hasta"
                  name="until"
                  formControlName="until"
                  placeholder=""
                  labelPlacement="floating"
                  fill="outline"
                  mode="md"
                  [min]="minUntilDate()"
                  helperText="Día y hora prevista máxima para salir de la parada"
                  [errorText]="errorText['until']"
                ></ion-input>
              </div>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col
              size-lg="6"
              size="12"
              class="ion-no-padding ion-padding-lg-end"
            >
              <ion-row>
                <ion-col>
                  <h3>Dirección</h3>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col>
                  <ion-button
                    size="small"
                    appPreventBlurPropagation
                    (click)="openModalAddressBook()"
                  >
                    <ion-icon
                      aria-hidden="true"
                      slot="start"
                      src="../assets/material-symbols/search_24dp.svg"
                    ></ion-icon>
                    Buscar dirección
                  </ion-button>
                  @if (!isAddressFromAddressBook() && !isAddressEditable()) {
                    <ion-button
                      size="small"
                      fill="outline"
                      appPreventBlurPropagation
                      (click)="openModalNewAddress()"
                    >
                      Nueva dirección
                    </ion-button>
                  } @else if (isAddressFromAddressBook()) {
                    <ion-button
                      (click)="modifyAddress()"
                      size="small"
                      fill="outline"
                    >
                      Modificar dirección
                    </ion-button>
                  }
                </ion-col>
              </ion-row>

              @if (isAddressFromAddressBook()) {
                <ion-row>
                  <ion-col>
                    <div class="freight-data-block">
                      <ion-icon
                        aria-hidden="true"
                        src="../assets/material-symbols/pin_drop_24dp.svg"
                      ></ion-icon>

                      <div>
                        <p class="fs-sm">
                          {{ currentStop().address.company }}
                        </p>
                        <p>{{ currentStop().address.street }}</p>
                        @if (currentStop().address.extraLine) {
                          <p>{{ currentStop().address.extraLine }}</p>
                        }
                        <p>{{ currentStop().address.postalCode }} {{ currentStop().address.city }}</p>
                        <p class="ion-text-uppercase">
                          <strong>
                            ({{ currentStop().address.countryCode }})
                            {{
                              `states.${currentStop().address.countryCode}${currentStop().address.stateCode}`
                                | translate
                            }}
                          </strong>
                        </p>
                        <ion-button
                          fill="outline"
                          size="small"
                          (click)="openMap(currentStop().address.coords)"
                        >
                          <ion-icon
                            aria-hidden="true"
                            slot="start"
                            src="../assets/material-symbols/map_24dp.svg"
                          ></ion-icon>
                          {{ 'freight.detail.map' | translate }}
                        </ion-button>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              } @else if (isAddressEditable()) {
                <ion-row>
                  <ion-col>
                    <ion-item>
                      <ion-label>
                        ({{ place().countryCode }})
                        {{ place().postalCode }}
                        <strong>{{ place().city }}</strong>
                      </ion-label>

                      <ion-button
                        slot="end"
                        size="small"
                        fill="outline"
                        shape="round"
                        appPreventBlurPropagation
                        (click)="openModalNewAddress()"
                      >
                        <ion-icon
                          src="../assets/material-symbols/edit_24dp.svg"
                          slot="icon-only"
                        ></ion-icon>
                      </ion-button>
                    </ion-item>

                    <div class="ion-padding-top">
                      <ion-input
                        type="text"
                        label="Empresa / razón social"
                        name="companyName"
                        formControlName="companyName"
                        placeholder="Razón social, nombre,..."
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        clearInput
                        helperText="Indique el nombre de la empresa a la que deba dirigirse el transportista en esta parada"
                        errorText="Error. Indique el nombre de la empresa a la que deba dirigirse el transportista en esta parada"
                      ></ion-input>
                    </div>

                    <div class="ion-padding-top">
                      <ion-input
                        type="text"
                        label="Domicilio"
                        name="streetAddress"
                        formControlName="streetAddress"
                        placeholder="Calle, número,..."
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        clearInput
                        helperText="Escriba el tipo de vía, nombre de la vía, número y otros datos identificativos del lugar"
                        errorText="Error. Escriba el tipo de vía, nombre de la vía, número y otros datos identificativos del lugar"
                      ></ion-input>
                    </div>

                    <p class="ion-margin-bottom-0 ion-padding-top fs-sm">
                      <strong>{{ 'freight.post.optional_data' | translate }}</strong>
                    </p>

                    <div class="ion-padding-top">
                      <ion-input
                        type="text"
                        label="Segunda línea de dirección"
                        name="streetAddress2"
                        formControlName="streetAddress2"
                        placeholder="Datos adicionales (urbanización,...)"
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        clearInput
                      ></ion-input>
                    </div>

                    <div class="ion-padding-top">
                      <ion-input
                        type="tel"
                        inputmode="tel"
                        label="Teléfono"
                        name="companyPhone"
                        formControlName="companyPhone"
                        placeholder=""
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        clearInput
                        [errorText]="errorText['companyPhone']"
                      ></ion-input>
                    </div>

                    <div class="ion-padding-top">
                      <ion-input
                        type="text"
                        label="CIF"
                        name="companyTaxNumber"
                        formControlName="companyTaxNumber"
                        placeholder=""
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        clearInput
                      ></ion-input>
                    </div>
                  </ion-col>
                </ion-row>
              }
            </ion-col>

            <ion-col
              size-lg="6"
              size="12"
              class="ion-no-padding ion-padding-lg-start"
            >
              @if (currentStopType() === EStopType.UNLOAD || currentStopType() === EStopType.UNLOAD_LOAD) {
                <ion-row>
                  <ion-col>
                    <h3>Datos de la operación de descarga</h3>
                  </ion-col>
                </ion-row>

                <ion-row>
                  @if (isLastStop()) {
                    <ion-col
                      sizeXl="12"
                      size-lg="12"
                      sizeMd="12"
                      size="12"
                    >
                      <p class="fs-xs ion-no-margin">
                        Los valores de peso y bultos a descargar se calculan automáticamente
                      </p>
                    </ion-col>
                    <ion-col
                      sizeXl="6"
                      size-lg="6"
                      sizeMd="6"
                      size="6"
                    >
                      <lib-ion-input-fake
                        [value]="currentStop().unloadedNetWeight?.toString() ?? '0'"
                        label="Peso a descargar"
                      ></lib-ion-input-fake>
                    </ion-col>

                    <ion-col
                      sizeXl="6"
                      size-lg="6"
                      sizeMd="6"
                      size="6"
                    >
                      <lib-ion-input-fake
                        [value]="currentStop().unloadedPackages?.toString() ?? '0'"
                        label="Nº de bultos"
                      ></lib-ion-input-fake>
                    </ion-col>
                  } @else {
                    <ion-col
                      sizeXl="6"
                      size-lg="6"
                      sizeMd="6"
                      size="6"
                    >
                      <ion-input
                        placeholder="Peso a descargar"
                        label="Peso a descargar"
                        type="number"
                        name="unloadedWeight"
                        formControlName="unloadedWeight"
                        fill="outline"
                        mode="md"
                        labelPlacement="floating"
                        helperText="Obligatorio, peso en kg"
                        errorText="Error. Es obligatorio indicar, en kg, el peso a descargar"
                      ></ion-input>
                    </ion-col>

                    <ion-col
                      sizeXl="6"
                      size-lg="6"
                      sizeMd="6"
                      size="6"
                    >
                      <ion-input
                        placeholder="Nº de bultos"
                        label="Nº de bultos"
                        type="number"
                        name="unloadedPackages"
                        formControlName="unloadedPackages"
                        fill="outline"
                        mode="md"
                        labelPlacement="floating"
                        helperText="Obligatorio, cantidad de bultos"
                        errorText="Error. Es obligatorio indicar la cantidad de bultos descargar"
                      ></ion-input>
                    </ion-col>
                  }
                </ion-row>
              }

              @if (currentStopType() === EStopType.LOAD || currentStopType() === EStopType.UNLOAD_LOAD) {
                <ion-row>
                  <ion-col>
                    <h3>Datos de la operación de carga</h3>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col
                    sizeXl="12"
                    size-lg="12"
                    sizeMd="12"
                    size="12"
                  >
                    <ion-input
                      placeholder="Descripción de la mercancía"
                      label="Descripción de la mercancía"
                      type="text"
                      name="nature"
                      formControlName="nature"
                      labelPlacement="floating"
                      fill="outline"
                      mode="md"
                      [counter]="true"
                      maxlength="50"
                      spellcheck="true"
                      helperText="Obligatorio, describa la mercancía"
                      [errorText]="errorText['nature']"
                    ></ion-input>
                  </ion-col>

                  <ion-col
                    sizeXl="6"
                    size-lg="6"
                    sizeMd="6"
                    size="6"
                  >
                    <ion-input
                      placeholder="kg..."
                      label="Peso a cargar"
                      type="number"
                      min="0"
                      name="weight"
                      formControlName="weight"
                      labelPlacement="floating"
                      fill="outline"
                      mode="md"
                      helperText="Obligatorio, peso en kg"
                      errorText="Error. Es obligatorio indicar, en kg, el peso a cargar"
                    ></ion-input>
                  </ion-col>

                  <ion-col
                    sizeXl="6"
                    size-lg="6"
                    sizeMd="6"
                    size="6"
                  >
                    <ion-input
                      placeholder="Nº de bultos"
                      label="Nº de bultos"
                      type="number"
                      min="0"
                      name="packages"
                      formControlName="packages"
                      labelPlacement="floating"
                      fill="outline"
                      mode="md"
                      helperText="Obligatorio, cantidad de bultos"
                      errorText="Error. Es obligatorio indicar la cantidad de bultos a cargar"
                    ></ion-input>
                  </ion-col>
                </ion-row>
              }

              <ion-row>
                <ion-col>
                  <h3>Información adicional (opcional)</h3>
                </ion-col>

                <ion-col
                  sizeXl="12"
                  size-lg="12"
                  sizeMd="12"
                  size="12"
                >
                  <ion-input
                    placeholder="Referencia de la parada"
                    label="Referencia de la parada"
                    type="text"
                    name="reference"
                    formControlName="reference"
                    labelPlacement="floating"
                    fill="outline"
                    mode="md"
                    [counter]="true"
                    maxlength="50"
                    clearInput
                  ></ion-input>
                </ion-col>

                <ion-col
                  sizeXl="12"
                  size-lg="12"
                  sizeMd="12"
                  size="12"
                >
                  <ion-textarea
                    label="Instrucciones"
                    placeholder="Escriba aquí..."
                    labelPlacement="floating"
                    mode="md"
                    fill="outline"
                    [autoGrow]="true"
                    [counter]="true"
                    maxlength="250"
                    spellcheck="true"
                    name="instructions"
                    formControlName="instructions"
                  ></ion-textarea>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-item-group>
  </form>
</ion-list>
